import React from 'react';
import { useParams } from 'react-router-dom';
import {
  FacebookIcon,
  FacebookShareButton, LinkedinIcon, LinkedinShareButton,
  OKIcon,
  OKShareButton, PinterestIcon, PinterestShareButton, TelegramIcon,
  TelegramShareButton, TumblrIcon, TumblrShareButton, TwitterIcon, TwitterShareButton,
  VKIcon,
  VKShareButton
} from 'react-share';
import { projectName } from '../../../config';


const SocialMediaButtons = ({ name, link, title }) => {
  let { lang } = useParams();
  return (<>
    { lang === 'ru' && <VKShareButton className="mr-2" url={ link }
                                      title={ name + ' - ' + title + ' ' + gettext('на') + ' ' + projectName }>
      <VKIcon size={36}/>
    </VKShareButton> }
    <FacebookShareButton className="mr-2" url={link}
                         quote={name + ' - ' + title + ' ' + gettext('на') + ' ' + projectName}
                         hashtag={'#' + projectName}>
      <FacebookIcon size={36}/>
    </FacebookShareButton>
    { lang === 'ru' && <OKShareButton className="mr-2" url={ link }
                                      title={ name + ' - ' + title + ' ' + gettext('на') + ' ' + projectName }>
      <OKIcon size={36}/>
    </OKShareButton> }
    { lang === 'ru' && <TelegramShareButton className="mr-2" url={ link }
                                            title={ name + ' - ' + title + ' ' + gettext('на') + ' ' + projectName }>
      <TelegramIcon size={36}/>
    </TelegramShareButton> }
    <TwitterShareButton
      url={ link }
      title={ name + ' - ' + title + ' ' + gettext('на') + ' ' + projectName}
      hashtag={'#' + projectName}>
      <TwitterIcon size={36}/>
    </TwitterShareButton>
    { lang !== 'ru' && <PinterestShareButton className="mr-2" url={ link }
                                             description={ name + ' - ' + title + ' ' + gettext('на') + ' ' + projectName }>
      <PinterestIcon size={36}/>
    </PinterestShareButton> }
    { lang !== 'ru' && <TumblrShareButton className="mr-2" url={ link }
                                          tags={[projectName]}
                                          title={ name + ' - ' + title + ' ' + gettext('на') + ' ' + projectName }>
      <TumblrIcon size={36}/>
    </TumblrShareButton> }
    { lang !== 'ru' && <LinkedinShareButton className="mr-2" url={ link }
                                            source={projectName}
                                            title={ name + ' - ' + title + ' ' + gettext('на') + ' ' + projectName }>
      <LinkedinIcon size={36}/>
    </LinkedinShareButton> }
  </>);
}

export default SocialMediaButtons;